// Reusable scrapbook sticker component with depth-based effects
export function ScrapbookSticker({
  src,
  alt = '',
  size = 80,
  rotation = 0,
  opacity = 1,
  depth = 'shallow', // 'shallow', 'mid', 'deep'
  className = '',
  style = {},
  removeBackground = false
}) {
  // Depth affects visual treatment
  const depthEffects = {
    shallow: {
      opacity: opacity * 0.85,
      filter: 'brightness(1) saturate(1)',
    },
    mid: {
      opacity: opacity * 0.75,
      filter: 'brightness(0.9) saturate(0.85)',
    },
    deep: {
      opacity: opacity * 0.65,
      filter: 'brightness(0.75) saturate(0.7)',
    }
  };

  const effects = depthEffects[depth] || depthEffects.shallow;

  // Enhanced white background removal
  const blendStyle = removeBackground ? {
    mixBlendMode: 'multiply',
    backgroundColor: 'transparent',
  } : {};

  return (
    <div
      className={`pointer-events-none ${className}`}
      style={{
        width: `${size}px`,
        transform: `rotate(${rotation}deg)`,
        ...style
      }}
    >
      <img
        src={src}
        alt={alt}
        className="pointer-events-none w-full h-auto"
        style={{
          opacity: effects.opacity,
          filter: effects.filter,
          ...blendStyle,
        }}
      />
    </div>
  );
}
